export default "__VITE_ASSET__B2JS0viR__"